import type { TFunction } from 'i18next';

import Yup from '@tmh-website/services/validation.service';
import { SelectOption } from '@tmh-website/ui/FormElements';

type QuestionTypeOptionValue = 'Invoice / Payment' | 'Shipping / Delivery' | 'Complaint' | 'Use of a product';
type SippingTypeOptionValue = 'ware_beim_transport_beschadigt' | 'bestellstatus_meiner_ware' | 'etwas_anderes';
type ManufacturerOptionValue =
  | 'keba'
  | 'alfen'
  | 'webasto/ampure'
  | 'evbox'
  | 'abl/wallbox'
  | 'go-e'
  | 'nrgkick'
  | 'juice'
  | 'sonstige';

export interface QuestionTypeOption extends SelectOption {
  value: QuestionTypeOptionValue;
}

export interface ManufacturerOption extends SelectOption {
  value: ManufacturerOptionValue;
}

export interface ShippingTypeOption extends SelectOption {
  value: SippingTypeOptionValue;
}

export type BusinessUnitChargingWeb2CaseFormValues = {
  first_name: string;
  last_name: string;
  company: string;
  postal_code: string;
  street: string;
  city: string;
  phone: string;
  email: string;
  question: QuestionTypeOption['value'] | undefined;
  invoice_order_number?: string;
  location_of_charging_infrastrucutre?: string;
  order_number?: string;
  message?: string;
  manufacturer?: string;
  'g-recaptcha-response': string;
  shipping_delivery?: SippingTypeOptionValue;
};

export const validationSchema = (t: TFunction<'translation', undefined>) =>
  new Yup.ObjectSchema({
    first_name: Yup.string().required(t('validation:mixed.required')),
    last_name: Yup.string().required(t('validation:mixed.required')),
    postal_code: Yup.string().required(t('validation:mixed.required')),
    street: Yup.string().required(t('validation:mixed.required')),
    city: Yup.string().required(t('validation:mixed.required')),
    phone: Yup.string()
      .matches(/^(\+?[0-9]+)$/)
      .required(t('validation:mixed.required')),
    company: Yup.string(),
    email: Yup.string().email(t('validation:string.email')).required(t('validation:mixed.required')),
    question: Yup.mixed<QuestionTypeOption['value']>().required(t('validation:mixed.required')),
    message: Yup.string().when('question', {
      is: (value: QuestionTypeOption['value']) => value !== undefined,
      then: Yup.string().required(t('validation:mixed.required')),
    }),
    invoice_order_number: Yup.string().when('question', {
      is: (value: QuestionTypeOption['value']) => value === 'Invoice / Payment',
      then: Yup.string().required(t('validation:mixed.required')),
    }),
    order_number: Yup.string().when('question', {
      is: (value: QuestionTypeOption['value']) =>
        value === 'Complaint' || value === 'Shipping / Delivery' || value === 'Use of a product',
      then: Yup.string().required(t('validation:mixed.required')),
    }),
    location_of_charging_infrastrucutre: Yup.string().when('question', {
      is: (value: QuestionTypeOption['value']) => value === 'Complaint' || value === 'Use of a product',
      then: Yup.string().required(t('validation:mixed.required')),
    }),
    manufacturer: Yup.string().when('question', {
      is: (value: QuestionTypeOption['value']) => value === 'Complaint' || value === 'Use of a product',
      then: Yup.string().required(t('validation:mixed.required')),
    }),
    shipping_delivery: Yup.string().when('question', {
      is: (value: QuestionTypeOption['value']) => value === 'Shipping / Delivery',
      then: Yup.string().required(t('validation:mixed.required')),
    }),
    'g-recaptcha-response': Yup.string().required(t('validation:mixed.required')),
  });
